import type { DeliveryAddress } from 'src/app/types/delivery';

import { useSessionData } from '../useSessionData';

const KEY = 'ACCOUNT_PAGE_ADDRESS_DATA';

const VERSION = '1';

export const ACCOUNT_PAGE_ADDRESS_DATA_KEY = `${KEY}.${VERSION}`;

interface AddressData {
  existingAddress?: DeliveryAddress;
  invalidAddress?: DeliveryAddress;
  suggestedAddress?: DeliveryAddress;
}

export function useAccountPageAddressData() {
  const { data, setData } = useSessionData<AddressData>(ACCOUNT_PAGE_ADDRESS_DATA_KEY);
  const dataObj = data ? (JSON.parse(data) as AddressData) : null;

  return {
    addressData: dataObj,
    setAddressData: async (newContext: AddressData) => {
      await setData(newContext);
    },
  };
}
